import { Fragment, ReactNode } from 'react'
import { TriangleAlert } from 'lucide-react'

const ATLAS_MARKUP = /\|A:([^:|]+)[^|]*\|a/g

const atlasIcons: Record<string, ReactNode> = {
  'services-icon-warning': (
    <TriangleAlert className='inline-block h-3 w-3 mx-0.5 align-[-2px] text-warning-foreground' />
  ),
}

const TimelineTooltipText = ({ text }: { text: string }) => {
  const parts = text.split(ATLAS_MARKUP)

  return (
    <>
      {parts.map((part, index) => (
        <Fragment key={index}>
          {index % 2 === 1 ? atlasIcons[part] ?? null : part}
        </Fragment>
      ))}
    </>
  )
}

export default TimelineTooltipText
